<nb-card size="medium">
    <nb-card-header>{{summaryView?.title}}</nb-card-header>
</nb-card>
